import React, { Component } from 'react';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';
import { addNewText, editObject, editFont } from "../../actions";
import ChoiceWidget from '../../components/ChoiceWidget';

import AlphaSelector from '../AlphaSelector';
import ColorPicker from '../ColorPicker';

import _find from 'lodash/find';

class TextPane extends Component {

  textAreaRef = React.createRef();

  constructor(props) {
    super(props);
    this.changeText = this.changeText.bind(this);
    this.changeColor = this.changeColor.bind(this);
    this.changeOpacity = this.changeOpacity.bind(this);
    this.changeFont = this.changeFont.bind(this);
    this.changeItalic = this.changeItalic.bind(this);
    this.changeBold = this.changeBold.bind(this);
    this.handleNewObject = this.handleNewObject.bind(this);
    this.renderNew = this.renderNew.bind(this);
    this.renderEdit = this.renderEdit.bind(this);
  }

  componentDidMount() {
    if (this.textAreaRef.current) {
      this.textAreaRef.current.focus();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.textAreaRef.current) {
      this.textAreaRef.current.focus();
    }
  }

  handleNewObject() {
    this.props.addNewText(uuidv4());
  }

  changeText(e) {
    this.props.editObject(this.props.sidebar.object.id, {
      text: e.target.value
    })
  }

  changeColor(color) {
    this.props.editObject(this.props.sidebar.object.id, {
      fill: color.hex
    })
  }

  changeOpacity(opacity) {
    this.props.editObject(this.props.sidebar.object.id, {
      opacity: opacity
    })
  }

  changeFont(font) {
    this.props.editFont(this.props.sidebar.object.id, {
      fontFamily: font.value
    }, font);
    // const surfaceId = this.props.objects.present.currentSurface.surface.id;
    // const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];
    // const observer = new FontFaceObserver(font.value);
    // observer.load(object.props.text).then(() => {
    //   this.props.editObject(this.props.sidebar.object.id, {
    //     fontFamily: font.value
    //   })
    // }).catch((err) => {
    //   console.error(err);
    // });
  }

  changeItalic() {
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];
    this.props.editObject(this.props.sidebar.object.id, {
      fontStyle: (object.props.fontStyle || '') === 'italic' ? '' : 'italic'
    })
  }

  changeBold() {
    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];
    const currentFont = object.font;

    this.props.editObject(this.props.sidebar.object.id, {
      fontFamily: object.props.fontFamily === currentFont.value ? currentFont.bold : currentFont.value
    });
  }

  renderNew() {
    return (
      <div className="t-container-sidebar-content">
        <h3>テキストの追加</h3>

        <button onClick={this.handleNewObject} className="btn btn-info btn-block"><i className="fa fa-plus"/> テキストを追加する</button>
      </div>
    )
  }

  renderEdit() {
    if (!this.props.sidebar.object) {
      return;
    }

    if (this.props.sidebar.object.type !== 'text') {
      return;
    }

    const surfaceId = this.props.objects.present.currentSurface.surface.id;
    const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];

    if (!object) {
      return;
    }

    const currentFont = _find(this.props.fonts.fonts, (font) => {
      return font.value === object.props.fontFamily || font.bold === object.props.fontFamily;
    }) || this.props.fonts.fonts[0];

    const isItalic = (object.props.fontStyle || '') === 'italic';
    const isBold = object.props.fontFamily === (object.font.bold || '');

    return (
      <div className="t-container-sidebar-content">
        <h3>テキストの編集</h3>

        <ChoiceWidget
          choices={this.props.fonts.fonts}
          data={currentFont}
          onSelect={this.changeFont}
          groupBy="lang"
          renderLabel={(value) => {
            return <span style={{fontFamily: value.value}}>{value.label}</span>;
          }}
          renderChoice={(value) => {
            return <span style={{fontFamily: value.value}}>{value.label}</span>;
          }}
          renderHeader={(key) => {
            return <span>{this.props.fonts.languages[key]}</span>;
          }}
        />

        <h3>テキストを入力してください</h3>
        <textarea ref={this.textAreaRef} className="form-control form-control-highlighted" value={object.props.text} onChange={this.changeText} rows={4} placeholder="テキストを入力してください"/>
        <div>
          <button className={"btn-icon " + (isBold ? 'active' : '')} onClick={this.changeBold}><img src={window.tProjectGlobals.assetBaseUrl + "img/bold-icon.png"} alt="" width="12"/>太字</button>
          <button className={"btn-icon " + (isItalic ? 'active' : '')} onClick={this.changeItalic}><img src={window.tProjectGlobals.assetBaseUrl + "img/italic-icon.png"} alt="" width="12"/>斜体</button>
        </div>
        <ColorPicker value={object.props.fill} name="colorpicker-1" onChange={this.changeColor}/>
        <AlphaSelector value={object.props.opacity || 1.0} onChange={this.changeOpacity}/>
      </div>
    )
  }

  render() {
    // if (this.props.sidebar.object && this.props.sidebar.object.type === 'text') {
    //   const surfaceId = this.props.objects.present.currentSurface.surface.id;
    //   const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];
    //
    //   if (object) {
    //     return this.renderEdit(object);
    //   }
    // }
    //
    // return this.renderNew();

    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        {this.renderNew()}
        {this.renderEdit()}
      </div>
    );
  }
}

TextPane = connect(f => f, {addNewText, editObject, editFont})(TextPane);
// TextPane = reduxForm({form: 'text'})(TextPane);

export default TextPane;


// WEBPACK FOOTER //
// ./src/components/Sidebar/TextPane.js